import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { FeedPage } from '@/pages/FeedPage';
import { RecordPage } from '@/pages/RecordPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { BlahblahDetailPage } from '@/pages/BlahblahDetailPage';
import { AdminPage } from '@/pages/AdminPage';
import { GroupsBrowsePage } from '@/pages/GroupsBrowsePage';
import { GroupDetailPage } from '@/pages/GroupDetailPage';
import { GroupMembersPage } from '@/pages/GroupMembersPage';
import { GroupSettingsPage } from '@/pages/GroupSettingsPage';
import { InvitePage } from '@/pages/InvitePage';
import { CategoriesPage } from '@/pages/CategoriesPage';
import { CategoryFeedPage } from '@/pages/CategoryFeedPage';
import { VoiceCallPage } from '@/pages/VoiceCallPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<FeedPage />} />
        <Route path="record" element={<RecordPage />} />
        <Route path="profile/:userId" element={<ProfilePage />} />
        <Route path="blahblah/:id" element={<BlahblahDetailPage />} />
        <Route path="groups" element={<GroupsBrowsePage />} />
        <Route path="groups/create" element={<GroupSettingsPage />} />
        <Route path="groups/:groupId" element={<GroupDetailPage />} />
        <Route path="groups/:groupId/members" element={<GroupMembersPage />} />
        <Route path="groups/:groupId/settings" element={<GroupSettingsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="categories/:slug" element={<CategoryFeedPage />} />
        <Route path="voice-call" element={<VoiceCallPage />} />
        <Route path="invite/:code" element={<InvitePage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
